window.countriesList = [
    {
        name: "Europe",
        "url": "https://www.officinecreative.store/",
        "cols": 2,
        "countries": {
            "Austria": "",
            "Belgium": "",
            "Bulgaria": "",
            "Croatia": "",
            "Cyprus": "",
            "Czech Republic": "",
            "Denmark": "",
            "Estonia": "",
            "Finland": "",
            "France": "",
            "Germany": "",
            "Greece": "",
            "Hungary": "",
            "Ireland": "",
            "Italy": "https://it.officinecreative.store",
            "Latvia": "",
            "Lithuania": "",
            "Luxembourg": "",
            "Malta": "",
            "Monaco": "",
            "Netherlands": "",
            "Northern Ireland": "",
            "Norway": "",
            "Poland": "",
            "Portugal": "",
            "Romania": "",
            "Slovakia": "",
            "San Marino": "",
            "Slovenia": "",
            "Spain": "",
            "Sweden": "",
            "Switzerland": "",
            "United Kindgom": ""
        }
    },
    {
        name: "America",
        "url": "https://us.officinecreative.store/",
        "countries": {
            "Argentina": "",
            "Brazil": "",
            "Canada": "",
            "Chile": "",
            "Cuba": "",
            "Mexico": "",
            "Perù": "",
            "United States": "",
            "Venezuela": ""
        }
    },
    {
        name: "Asia",
        "url": "https://www.officinecreative.store/",
        "countries": {
            "Australia": "",
            "China": "",
            "Hong Kong": "",
            "India": "",
            "Indonesia": "",
            "Japan": "",
            "New Zealand": "",
            "Qatar": "",
            "Singapore": "",
            "South Korea": "",
            "United Arab Emirates": "",
            "Malaysia": "",
            "Oman": "",
            "Saudi Arabia": "",
            "Thailand": ""
        }
    },
    {
        name: "Rest of the world",
        "url": "https://www.officinecreative.store/",
        cols: "2",
        "countries": {
            "Israel": "",
            "Marocco": "",
            "Tunisia": "",
            "Albania": "",
            "Montenegro": "",
            "Serbia": "",
            "Ukraine": "",
            "Bosnia Herzegovina": "",
            "Egypt": "",
            "South Africa": "",
            "Kuwait": "",
            "Kazakhstan": "",
            "Turkey": "",
            "Iceland": "",
            "Georgia": ""
        }
    }
]


